import { getCurrentQueueName as getCurrentQueueNameReact  } from '@/react-app/common/utils/jobItemHistory';
(function() {
  'use strict';
  angular.module('eva2-angular').service('getCurrentQueueName', function() {
    function getCurrentQueueName(mostRecentHistory, queues) {
      return  getCurrentQueueNameReact(mostRecentHistory, queues);
    }
    return getCurrentQueueName;
  });
})();